import {
  type QueryFunctionContext,
  type UseQueryOptions,
} from '@tanstack/react-query';
import ms from 'ms';

import { queryKeysDeliveryNote } from '../queryKeys';

import { fetchDeliveryNotesByIdsAdmin } from './fetchDeliveryNotesByIdsAdmin';
import {
  type DeliveryNotesByIdsAdminRequest,
  type DeliveryNotesByIdsAdminResponse,
} from './types';

export const getDeliveryNotesByIdsAdminQueryOptions = ({
  ids,
  options = {},
}: {
  ids: DeliveryNotesByIdsAdminRequest['ids'];
  options?: Omit<
    UseQueryOptions<DeliveryNotesByIdsAdminResponse>,
    'queryFn' | 'queryKey'
  >;
}): UseQueryOptions<DeliveryNotesByIdsAdminResponse> => {
  const normalizedIds = [...ids].sort();

  return {
    enabled: Boolean(ids?.length),
    queryFn: async ({ signal }: QueryFunctionContext) =>
      fetchDeliveryNotesByIdsAdmin({ ids: normalizedIds }, { signal }),
    queryKey: queryKeysDeliveryNote.getByIds(normalizedIds),
    staleTime: ms('60s'),
    ...options,
  };
};
